import React from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  styled as MuiStyled,
} from "@material-ui/core";
import styled from "styled-components";

import { Box as VPQBox } from "vqp-common";

export const Card = styled(VPQBox)`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  max-width: 815px;
  min-width: auto;
  .MuiTypography-root {
    font-size: 14px;
  }
  .MuiOutlinedInput-root {
    border-radius: 10px;
  }
`;

export const FormDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  @media only screen and (max-width: 872px) {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 12px;
    padding: 16px;
    border: 1px solid;
    border-radius: 10px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  gap: 32px;
  align-items: ${(props) => (props.center ? "center" : "flex-end")};
  margin-bottom: ${(props) => (props.removeMarginBottom ? "0" : "24px")};
  @media only screen and (max-width: 872px) {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 12px;
    padding: 16px;
    border: 1px solid;
    border-radius: 10px;
  }
`;

export const FormPartialDiv = styled(Box)`
  display: flex;
  align-items: center;
`;

export const FormLabel = styled(Typography)`
  margin-bottom: 8px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
`;

export const FormlLabelPartial = styled(Typography)`
  margin-right: ${(props) => props.marginRight || "6px"} !important;
  width: ${(props) => props.width || "auto"} !important;
  flex: ${(props) => props.flex || "none"} !important;
`;

export const FormLabelControl = styled(FormControlLabel)`
  width: ${(props) => props.width || "175px"};
  margin-right: 0 !important;
  .MuiFormControlLabel-label {
    margin-left: 12px;
  }
`;

export const Label = styled(Typography)`
  margin-bottom: 8px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
`;

export const Table = styled.div`
  padding: 10px 18px;
  border: 1px solid #949494;
  border-radius: 12px;
`;

export const TableHead = styled.div`
  display: flex;
  gap: 8px;
  flex: ${(props) => props.flex || "none"};
`;

export const TableColumn = styled.div`
  font-size: 10px;
  width: ${(props) => props.width || "20%"};
  max-width: ${(props) => props.width || "auto"};
  min-width: ${(props) => props.width || "auto"};
  font-weight: ${(props) => props.bold || "none"};
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: ${(props) => (props.gap ? "8px" : "none")};
`;

export const ButtonContainer = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

export const IOSSwitch = MuiStyled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#119C4A",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#F00019",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export const UnavailableDeliveryTypeMessage = styled.span`
  font-size: 0.875rem;
`;
